class CustomError extends Error {
  override readonly name: string;
  override readonly message: string;
  override readonly stack?: string;
  readonly cause?: unknown;

  constructor(message: string, cause?: unknown) {
    super(message);
    this.name = this.constructor.name;
    this.message = message;
    this.stack = new Error(message).stack;
    this.cause = cause;
  }
}

export class MissingApiClientError extends CustomError {
  constructor(cause?: Error) {
    super('API client is not set. Please set the API client before making requests.', cause);
  }
}

export class AuthorizationError extends CustomError {
  constructor(cause?: Error) {
    super('Authorization failed. Please check your credentials or token.', cause);
  }
}

export class NetworkError extends CustomError {
  constructor(message = 'Network connection problem. Please check your internet connection.', cause?: Error) {
    super(message, cause);
  }
}

export class UploadChunkError extends CustomError {
  constructor(chunkNumber: number, cause?: Error) {
    super(`Failed to upload chunk ${chunkNumber}.`, cause);
  }
}

export class InvalidStateError extends CustomError {
  constructor({ action, cause, status }: { action: string; cause?: Error; status: string }) {
    super(`You cannot call ${action} in ${status}.`, cause);
  }
}

export class ChecksumError extends CustomError {
  constructor(cause?: Error) {
    super('Failed to calculate SHA256 checksum', cause);
  }
}

export class UnknownError extends CustomError {
  constructor(cause?: unknown) {
    super('Unknown error occurred', cause);
  }
}

export class CreateMediaError extends CustomError {
  constructor(cause?: unknown) {
    super('Failed to create chunked upload', cause);
  }
}

export class UnreachableError extends CustomError {
  constructor(cause?: unknown) {
    super('Unreachable code', cause);
  }
}

export class AbortedError extends CustomError {
  constructor(cause?: Error) {
    super('Upload was aborted', cause);
  }
}
